const flexDashboardGlobalSettings = {
    global: {
        splitterSize: 4,
        tabClassName: 'flex-dashboard--tab',
        tabEnableClose: false,
        tabEnableRename: false,
        tabSetHeaderHeight: 24,
        tabSetTabStripHeight: 24,
        tabSetEnableMaximize: false, // Disable double-click to maximize
    },
};

export default function getDashboardConfig(dashboardConfig) {
    return {...flexDashboardGlobalSettings, ...dashboardConfig};
}
